import { Skeleton } from "@/components/ui/skeleton";

/** The signed-in frame before the app starts: rail, header and padding where the shell will draw
    them, so first paint is the layout the screen settles into, not a page that jumps sideways. */
export function ShellPending() {
  return (
    <div className="flex min-h-svh w-full">
      <div className="bg-sidebar text-sidebar-foreground border-sidebar-border hidden w-64 shrink-0 flex-col gap-4 border-r px-3 py-3 md:flex">
        <span className="py-1 text-base font-semibold tracking-tight">
          People<span className="text-primary"> AI</span>
        </span>
        <Skeleton className="h-9 w-full" />
        <div className="space-y-3 pt-2">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-4 w-36" />
        </div>
      </div>
      <div className="bg-background flex min-w-0 flex-1 flex-col">
        <div className="bg-background min-h-14 border-b" />
        <div className="flex-1 space-y-6 p-4 md:p-6 lg:p-8">
          <Skeleton className="h-8 w-64 max-w-full" />
          <Skeleton className="h-4 w-96 max-w-full" />
          <Skeleton className="h-64 w-full rounded-xl" />
        </div>
      </div>
    </div>
  );
}
